import React from 'react'

export default function Allimg() {
  return (
    <div className='img-pad'>
        <img src="/image/image 1174.png" alt="" />
    </div>
  )
}
